import React, { useState } from 'react';
import { useTranslation } from '@hooks/useTranslation';
import { Collection } from '@components/common';
import './ConsumptionsPage.scss';

export const ConsumptionsPage = () => {
    const { t } = useTranslation();
    const [refreshTrigger, setRefreshTrigger] = useState(0);

    const handleRefresh = () => {
        setRefreshTrigger(prev => prev + 1);
    };

    const formatDate = (dateString) => {
        if (!dateString) return '-';
        return new Date(dateString).toLocaleString();
    };



    return (
        <div className="consumptions-page">
            <div className="consumptions-page__header">
                <h1 className="consumptions-page__title">{t('consumption.page_title')}</h1>
                <p className="consumptions-page__description">
                    {t('consumption.page_description')}
                </p>
            </div>

            <Collection
                modelName="consumptions"
                apiEndpoint="consumptions"
                refreshTrigger={refreshTrigger}
                onRefresh={handleRefresh}
                searchFields={['resource.name', 'user.name', 'notes']}
                sortFields={[
                    { key: 'consumed_at', label: t('consumption.consumed_date') },
                    { key: 'quantity_consumed', label: t('consumption.quantity_consumed') }
                ]}
                filterOptions={[
                    {
                        key: 'resource_id',
                        label: t('consumption.resource'),
                        type: 'select',
                        endpoint: 'resources'
                    }
                ]}
                readOnly={true} // Consumptions cannot be edited or deleted
            />
        </div>
    );
};

export default ConsumptionsPage;
